import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import { ResourceType } from '@/api/generated'

export interface ResourceState {
  resource: ResourceViewModel
  resources: ResourceViewModel[]
}

export function emptyResourceState(): ResourceState {
  return {
    resource: {
      location: 'undefined',
      id: -1,
      name: 'undefined',
      type: ResourceType.FILE,
    },
    resources: [],
  }
}
